/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DTOEditInsuranceModal from './DTOEditInsuranceModal';
import EditInsuranceModalPresenter from './EditInsuranceModalPresenter';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { setInsuranceList } from '../../../../infra/aggregates/myProfile/insuranceAggregates/insuranceListSlice';
import { setExpiredInsuranceList } from '../../../../infra/aggregates/myProfile/insuranceAggregates/expiredInsuranceSlice';

import toast from 'react-hot-toast';
import { insuranceServices } from '../../../../api/services/insuranceServices';
import _ from 'lodash';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  data: any;
  trans?: any;
}

const EditInsuranceModalController = ({
  isModalOpen,
  closeModal,
  data,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const storeInsurances: any = useAppSelector(
    (state) => state.insuranceListSlice?.insuranceList,
  );
  const storeExpiredInsurances: any = useAppSelector(
    (state) => state.expiredInsuranceSlice?.expiredInsurance,
  );

  const [allInsurers, setAllInsurers] = useState([]);
  const [allPolicies, setAllPolicies] = useState([]);

  const dispatch = useAppDispatch();

  const getData = (data: any) => {
    editInsurance(data);
  };

  const callBackGetInsurerTypes = (data: any) => {
    setAllInsurers(data);
  };
  const callBackGetPolicyTypes = (data: any) => {
    setAllPolicies(data);
  };

  async function editInsurance(data: any) {
    if (selector && data) {
      const empId: any = selector.emp_id;
      const formData: any = new FormData();

      formData.append('emp_id', empId);
      formData.append('id', data.id);
      formData.append('insurer', data.insurer);
      formData.append('policy_type', data.policy_type);
      formData.append('policy_number', data.policy_number);
      formData.append('start_date', data.start_date);
      formData.append('end_date', data.end_date);
      formData.append('category', data.category);
      formData.append('amount', data.amount);
      if (data.attachments) {
        formData.append('attachments', data.attachments);
      }
      formData.append('locale', localStorage.getItem('emplang'));
      formData.append('removed', data?.removed);

      await insuranceServices
        .editInsurance(formData)
        .then((response) => {
          if (response.response == 'success') {
            const temp = [...storeInsurances];
            const tempExpired = [...storeExpiredInsurances];
            const expire_date = new Date(response?.data?.expiry_date);
            if (expire_date > new Date() || expire_date == new Date()) {
              const editedList = _.filter(temp, (data: any) => {
                return data.id !== response?.data?.id;
              });

              editedList.push(response?.data);
              dispatch(setInsuranceList(editedList));
            } else {
              /* Update active insurance, by removing from active insurance if edited insurance is expired */
              const _activeInsurance = _.filter(temp, (data: any) => {
                return data.id !== response?.data?.id;
              });
              dispatch(setInsuranceList(_activeInsurance));
              //-----

              const editedList = _.filter(tempExpired, (data: any) => {
                return data.id !== response?.data?.id;
              });
              editedList.push(response?.data);
              dispatch(setExpiredInsuranceList(editedList));
            }
            toast.success(trans('Updated Successfully'));
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    }
  }

  return (
    <>
      <DTOEditInsuranceModal
        setAllInsurerTypesData={callBackGetInsurerTypes}
        setAllPolicyTypesData={callBackGetPolicyTypes}
      />

      <EditInsuranceModalPresenter
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allInsurerTypes={allInsurers}
        allPolicyTypes={allPolicies}
        editedData={data}
        trans={trans}
      />
    </>
  );
};

export default EditInsuranceModalController;
